/**
* 订单管理 交易订单
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item> 品牌列表-{{name}}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.name" placeholder="输入品牌名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit1()">添加</el-button>

      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="groupId" label="品牌ID">
      </el-table-column>
      <el-table-column prop="groupName" label="品牌名称">
      </el-table-column>
      <el-table-column prop="rateBase" label="基础折扣">
      </el-table-column>
      <el-table-column prop="rateSale" label="买单折扣">
      </el-table-column>
      <el-table-column prop="ver" label="版本号">
      </el-table-column>

      <!-- <el-table-column prop="state" label="图片">
				<template slot-scope="scope">
					<el-image :src="url + scope.row.logo" lazy></el-image>
				</template>
			</el-table-column> -->


      <el-table-column align="center" label="操作" min-width="100">
        <template slot-scope="scope">
          <el-button size="mini" v-if="scope.row.state!=0  "
            @click="handleEdit(scope.$index, scope.row.groupId)">移除品牌</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-form-item label="选泽品牌" prop="roleName">

          <el-select style="width:100%" v-model="editForm.groupId" filterable remote placeholder="请输入关键词" size="medium"
            :remote-method="getMchGroupListPage">
            <el-option v-for="item in channellist" :key="item.groupId" :label="item.groupName" :value="item.groupId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="成本价例" prop="appId">
          <el-input size="small" v-model="editForm.rateBase" auto-complete="off" placeholder="请输入成本价例"></el-input>
        </el-form-item>
        <el-form-item label="销售价例" prop="appId">
          <el-input size="small" v-model="editForm.rateSale" auto-complete="off" placeholder="请输入销售价例"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button v-if="title == '添加'" size="small" type="primary" :loading="loading" class="title"
          @click="submitForm('editForm')">添加
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getChannelGroupList,
    delChannelGroup,
    getMchGroupListPage,
    groupJoinChannel
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        name: this.$route.query.name,
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '预览',
        listData: [],
        channellist:[],
        formInline: {
          page: 1,
          limit: 20,
          name: '',
          channelId: this.$route.query.id,
        },
        editForm: {
          userId: JSON.parse(localStorage.getItem('userdata')).muId,
          channelId: this.$route.query.id,
          groupId: '',
          rateBase: '',
          rateSale: ''
        },
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },

    created() {
      this.getdata(this.formInline)
      this.getMchGroupListPage()
    },
    methods: {
      getMchGroupListPage(query) {
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "page": 1,
          "pageSize": 10,
          "name": query,
        }
        // this.channellist = []
        getMchGroupListPage(pro)
          .then(res => {
            if (res.code == 0) {
              this.channellist = res.data.list
              console.log(this.channellist)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
      },
      getdata(parameter) {
        this.loading = true
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "page": parameter.page,
          "pageSize": parameter.limit,
          channelId: parameter.channelId,
          name: parameter.name
        }
        getChannelGroupList(pro)
          .then(res => {
            this.loading = false
            if (res.code == 0) {
              this.listData = res.data.list
              // 分页赋值
              this.pageparm.currentPage = res.data.pageNum
              this.pageparm.pageSize = res.data.pageSize
              this.pageparm.total = res.data.total

            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
      },
      search() {
        this.getdata(this.formInline)
      },
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      handleEdit(row, id) {
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "groupId": id,
          channelId: this.formInline.channelId,
        }
        delChannelGroup(pro)
          .then(res => {
            this.loading = false
            if (res.code == 0) {
              this.search()

            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
      },
      handleEdit1: function(index, row) {
        this.editFormVisible = true
        this.title = '添加'
      },
      submitForm() {
        let pro = this.editForm
        groupJoinChannel(pro)
          .then(res => {
            this.loading = false
            if (res.code == 0) {
              this.search()
              this.closeDialog()

            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
      },
      closeDialog() {
        this.editFormVisible = false
        this.editForm = {
          userId: JSON.parse(localStorage.getItem('userdata')).muId,
          channelId: this.$route.query.id,
          groupId: '',
          rateBase: '',
          rateSale: ''
        }
      }
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/goods/brand.vue